// React js default imports
import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
//Date time picker
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
// Redux
import { Provider } from "react-redux";
import store from "./redux";

import './fix.scss';
// Global scss & css file
import "assets/scss/global.scss";
// import "assets/fonts/lato/fonts.css";
import "tailwind.css";

// Toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Importing main app
import App from "App";

// Rendering main application into react dom
ReactDOM.render(
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
  <Provider store={store}>
    <App />
    <ToastContainer />
  </Provider></MuiPickersUtilsProvider>,
  document.getElementById("root")
);

serviceWorker.register();
